const formats = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'code',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'script',
  'link',
  'image',
  'video',
  'color',
  'background',
  'align',
];

export default formats;
